export enum DepartmentsEnum {
  MARKETING = "MARKETING",
  SALES = "SALES",
  DESIGN = "DESIGN",
  DEVELOPMENT = "DEVELOPMENT",
  FINANCES = "FINANCES",
}
